import api from "../../Api/feathers-client";
import { convertMinToSecond } from "../../Js/TimeAndDate";

// Call backend service to get all tasks
export const getTaskList = async (loggedInUser, site_uuid, skip, limit, query = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: {
          ...query,
          created_by: loggedInUser,
          site_uuid: site_uuid,
          is_deleted: false,
          $sort: {
            created_at: -1,
          },
          $skip: skip,
          $limit: limit
        },
      });
      console.log(":::SSSS:::SSSS",response);
      resolve({
        status: 200,
        message: "All Task",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected task
export const getTaskInfo = async (uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: {
          uid: uid,
          site_uuid: site_uuid,
          is_deleted: false,
        },
      });

      resolve({
        status: 200,
        message: "All Task",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected task assets
export const getTaskAssets = async (asset_ids, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assets").find({
        query: {
          $select: ["id", "asset_name", "asset_uid", "content"],
          asset_uid: {
            $in: asset_ids,
          },
          site_uuid: site_uuid,
          $limit: 500,
        },
      });

      resolve({
        status: 200,
        message: "All Task",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to create task
export const createTask = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").create(data, {});

      resolve({
        status: 200,
        message: "Task Created",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update task
export const updateTask = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Task Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// To create array of objects for given assets
export const createSelectedAssetsArray = (assets) => {
  return assets.map((val) => {
    return {
      id: val.asset_uid,
      name: val.asset_name,
      duration: convertMinToSecond(
        typeof assets[0]["content"] == 'string' ? JSON.parse(assets[0]["content"])["content"]["info"]["duration"] : assets[0]["content"]["content"]["info"]["duration"]
      ),
    };
  });
};

// To check task is attempted by any learner or not
export const checkTaskAttemptedOrNot = (taskid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          context: {
            taskID: taskid,
          },
          site_uuid: site_uuid,
          $limit: 1,
        },
      });

      resolve({
        status: 200,
        message: "Task Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
